import { useCallback } from 'react';

import { TServerSendRequest } from '../types';
import { useGenericSend } from './useGenericSend';

export const useGetPanicButtonConfiguration = () => {
    const send = useGenericSend();

    return useCallback(async (): Promise<{ isEnabled: boolean; selfExcludeTime: number | null }> => {
        const { data } = await send<TServerSendRequest, { enabled?: boolean; selfExcludeTime?: number }>({
            ID: 35674,
            description: 'Get Panic Button Configuration',
            responses: [35675, 35676]
        });

        return { isEnabled: data?.enabled || false, selfExcludeTime: data?.selfExcludeTime || null };
    }, [send]);
};
